import React from 'react';
import { Paper, Stack } from '@mantine/core';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import type { ContestEmptyStateCardProps } from './types';
import useStyles from './ContestEmptyStateCard.styles';

function ContestEmptyStateCard({
  title,
  description,
  icon,
  actions,
  ...paperProps
}: ContestEmptyStateCardProps) {
  const isMobile = useIsMobile();
  const { classes } = useStyles({ isMobile });

  return (
    <Paper className={classes.container} /* eslint-disable-line local-rules/use-theme-tokens */ p={32} radius={16} {...paperProps}>
      <Stack align="center" /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8}>
        {icon}

        <Stack align="center" spacing="xs">
          <Text ta="center" variant="headline-xl" className={classes.title}>
            {title}
          </Text>

          <Text variant="body-large" className={classes.description}>
            {description}
          </Text>
        </Stack>

        {actions?.length > 0 && (
          <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={12} className={classes.actionsContainer}>
            {actions.map((action) => {
              const { text, onClick, ...buttonProps } = action;
              return (
                <Button
                  key={text}
                  variant="tertiary-fill"
                  size="medium"
                  onClick={onClick}
                  className={classes.actionButton}
                  {...buttonProps}
                >
                  {text}
                </Button>
              );
            })}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}

export default ContestEmptyStateCard;
